import { useState, useEffect } from "react";
import { getApiBaseUrl } from "constants/BaseUrlApi";

function formatBlogDate(isoString) {
  const date = new Date(isoString);
  return date
    .toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })
    .toUpperCase();
}

export function slugify(text) {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
}

function normalizeBlog(post) {
  return {
    id: post.id,
    slug: post.slug || slugify(post.title),
    title: post.title,
    content: post.content,
    image: post["cover-image"],
    date: formatBlogDate(post["created-at"]),
    metaDescription: post["meta-description"] ?? null,
    keywords: post.keywords ?? null,
    section: post.section ?? null,
    author: post.author ?? null,
  };
}

export default function useBlogs() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();

    fetch(`${getApiBaseUrl()}/api/v1/public/blogs`, {
      signal: controller.signal,
    })
      .then((res) => {
        console.log("res", res.ok);
        if (!res.ok) throw new Error("Failed to load blog posts");
        return res.json();
      })
      .then((data) => {
        const published = data.data
          .filter((post) => post.status === "published")
          .map(normalizeBlog);
        setBlogs(published);
        setLoading(false);
      })
      .catch((err) => {
        if (err.name === "AbortError") return;
        setError("Unable to load posts. Please try again later.");
        setLoading(false);
      });

    return () => controller.abort();
  }, []);

  return { blogs, loading, error };
}
